<template>
  <v-container grid-list-lg fluid>
    <v-row>
      <!-- <h3>Manejo de Fechas de Cobro</h3> -->
      <v-spacer></v-spacer>
      <v-btn @click="load" small text>Refrescar</v-btn>
    </v-row>
    <v-divider></v-divider>

    <v-row>
      <v-col>
        <v-card flat>
          <v-card-title>
            <span v-if="!esAlta">Modificación de Fecha de Cobro</span>
            <span v-if="esAlta">Alta de Fecha de Cobro</span>

            <span v-if="esAlta" class="green--text">
              (Consultando Deudas de la Persona...
              <v-progress-circular
                indeterminate
                size="24"
                color="green"></v-progress-circular
              >)</span
            >
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-divider></v-divider>

    <v-card flat>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-select
              v-model="registro.tipoSubSituacionLaboralId"
              :items="listSubSituacionesLaborales"
              item-text="descripcion"
              item-value="id"
              label="Sub-Situación Laboral" />
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-text-field
              v-model="registro.anio"
              label="Año"
              type="number"
              max="2100" />
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-text-field
              v-model="registro.mes"
              label="Mes"
              type="number"
              min="1"
              max="12" />
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-text-field
              v-model="registro.ultimoDigitoDNI"
              label="Último Dígito DNI"
              type="number"
              min="0"
              max="9" />
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-text-field
              v-model="registro.fechaCobro"
              label="Fecha de Cobro"
              type="date" />
          </v-col>

          <v-col cols="12" sm="6" md="2">
            <v-text-field
              v-model="registro.diaCobro"
              label="Día Cobro"
              type="number"
              min="0"
              max="31" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />
      <!-- {{ registro }} -->
      <v-card-actions>
        <v-spacer />

        <v-btn text color="grey" @click="hide(false)"> Cerrar </v-btn>

        <!-- <v-btn text color="grey" @click="hide(false)"> Cerrar </v-btn> -->

        <v-btn color="primary" @click="altaRegistro"> Confirmar </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Vue from "vue";
import { http } from "@/axios";

import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

const EMPTY_ID = "00000000-0000-0000-0000-000000000000";

export default {
  data() {
    return {
      esAlta: false,
      tipoSubSituacionLaboralId: 0,
      mes: 0,
      anio: 0,
      ultimoDigitoDNI: 0,
      fechaCobro: "",
      cuotaSeldiaCobroeccionada: null,
      estadoId: 0,
      listSubSituacionesLaborales: [],
      registro: null,
    };
  },

  props: {
    //     info: { type: String, required: false, default: EMPTY_ID },
    //   },

    registroId: {
      type: String,
      required: false,
      default: EMPTY_ID,
    },
  },

  created() {
    this.load();
    this.loadSubSituacionesLaborales();
  },
  watch: {
    "$store.state.UiConfig"() {},
  },
  computed: {
    ...mapGetters(["getActionFromLink", "user"]),
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "setActiveSubTask",
      "hideActiveTask",
      "hideActiveSubTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    hide(cerrarRelacionados) {
      //esto lo hago para que no se buguee cuando lo abro como subtask o task
      if (this.isSubTask) this.hideActiveSubTask();
      else this.hideActiveTask(cerrarRelacionados);
    },

    async load() {
      this.loading = true;

      try {
        const id = this.registroId || "00000000-0000-0000-0000-000000000000";
        const result = await http.get(
          `Cobranzas/fechacobro?id=${id}&anio=2026&mes=1&subTipoSituacionLaboralId=4&ultimoNumeroDocumento=7`,
        );

        this.registro = result;
        if (this.registro.fechaCobro) {
          this.registro.fechaCobro = this.registro.fechaCobro.substring(0, 10);
        }
      } catch (error) {
        this.alertError(error);
      } finally {
        this.loading = false;
      }
    },
    // async editItem(item) {
    //   var paramis = {
    //     width: 900,
    //     visible: true,
    //     registroId: item.id,
    //   };
    //   this.setActiveTask({ task: "manejo-fechas-cobro", props: paramis });
    // },

    async altaRegistro() {
      //if (!this.validarAlta()) return;
      var params = {};
      params.id = this.registro.id || EMPTY_ID;
      params.tipoSubSituacionLaboralId =
        this.registro.tipoSubSituacionLaboralId;
      params.anio = this.registro.anio;
      params.mes = this.registro.mes;
      params.ultimoDigitoDNI = this.registro.ultimoDigitoDNI;
      params.fechaCobro = this.registro.fechaCobro;
      params.diaCobro = this.registro.diaCobro;
      params.EstadoId = 1;

      try {
        this.saving = true;
        await http.post(
          "Cobranzas/updateCalendario",
          JSON.stringify({ CalendarioANSES: params }),
        );
        this.alertSuccess("El calendario se ha actualizado.");
        this.hide(false);
        // this.limpiar();
      } catch (error) {
        // Error
        this.alertError(error);
      }

      this.saving = true;
    },

    async loadSubSituacionesLaborales() {
      this.loading = true;
      try {
        var result = await http.get("tiposSubSituacionLaboral"); // traigo todas
        this.listSubSituacionesLaborales = result.list;
        // this.listSubSituacionesLaborales.push("(Todos)");
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.item {
  min-height: 110px;
  max-height: 110px;
  min-width: 80px;
  margin: 5px;
}
</style>
